let cityList = [{
	"provinceCode": "370000",
	"provinceName": "山东省",
	"cityInfoList": [{
		"id": 227,
		"name": "威海市",
		"pinyin": "weihai",
		"acronym": "weihai",
		"rank": "C",
		"firstChar": "W"
	}, {
		"id": 60,
		"name": "青岛市",
		"pinyin": "qingdao",
		"acronym": "qd",
		"rank": "B",
		"firstChar": "Q"
	}, {
		"id": 96,
		"name": "济南市",
		"pinyin": "jinan",
		"acronym": "jn",
		"rank": "B",
		"firstChar": "J"
	}]
},
// {
// 	"provinceCode": "510000",
// 	"provinceName": "四川省",
// 	"cityInfoList": [{
// 		"id": 310,
// 		"name": "乐山市",
// 		"pinyin": "leshan",
// 		"acronym": "ls",
// 		"rank": "D",
// 		"firstChar": "L"
// 	}, {
// 		"id": 59,
// 		"name": "成都市",
// 		"pinyin": "chengdu",
// 		"acronym": "cd",
// 		"rank": "A",
// 		"firstChar": "C"
// 	}]
// },
 {
	"provinceCode": "110000",
	"provinceName": "北京市",
	"cityInfoList": [{
		"id": 1,
		"name": "北京",
		"pinyin": "beijing",
		"acronym": "bj",
		"rank": "S",
		"firstChar": "B"
	}, {
		"id": 1283,
		"name": "门头沟区",
		"pinyin": "mentougouqu",
		"acronym": "mentougouqu",
		"rank": "F",
		"firstChar": "M"
	}]
},{
	"provinceCode": "120000",
	"provinceName": "天津市",
	"cityInfoList": [{
		"id": 40,
		"name": "天津",
		"pinyin": "tianjin",
		"acronym": "tj",
		"rank": "A",
		"firstChar": "T"
	}]
}]
export default cityList